import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Dropdown, Input, Checkbox} from 'semantic-ui-react';
import {WARRANTIES_TYPES} from '../../../warranties/constants';
import {Actions} from '../../../common/actions';

const {
  addAllWarrantyChecked,
  removeAllWarrantyChecked,
  addWarrantyChecked,
  removeWarrantyChecked,
} = Actions;

export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};

export const DefaultColumnFilter = ({'column': {filterValue, setFilter}}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    />
  );
};

export const SelectColumnFilter = ({
  'column': {filterValue, setFilter, id},
}) => {
  return (
    <Dropdown
      className='filter-selection'
      selection
      defaultValue='TODOS'
      value={filterValue}
      options={WARRANTIES_TYPES}
      onChange={(e, {value}) => {
        const currentValue = value !== 'TODOS' ? value : null;
        setFilter(currentValue);
      }}
    />
  );
};

export const IndeterminateCheckbox = ({
  selectedStatus,
  code,
  checked,
}) => {
  const dispatch = useDispatch();
  const disableStatus = selectedStatus === 'TODOS' || selectedStatus === '01';

  const handleChange = () => {
    if (checked) {
      dispatch(removeWarrantyChecked(code));
    } else if (!checked) {
      dispatch(addWarrantyChecked(code));
    }
  };

  return <Checkbox checked={checked} onChange={handleChange} disabled={disableStatus} />;
};

export const IndeterminateAllCheckbox = ({
  'column': {filter},
  filteredRows,
}) => {
  const disableStatus = filter === 'TODOS' || filter === '01';
  const isDataPresent = filteredRows && filteredRows.length;
  const [allSelection, setAllSelection] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (allSelection) {
      const deselectionFromAll = filteredRows.some((item) => (
        !item.original.checked
      ));
      setIsIndeterminate(deselectionFromAll);
    }
  }, [filteredRows]);

  const handleAllSelectionChange = () => {
    if (!allSelection) {
      dispatch(addAllWarrantyChecked(filteredRows));
    } else if (allSelection) {
      dispatch(removeAllWarrantyChecked(filteredRows));
      setIsIndeterminate(false);
    }
    setAllSelection(!allSelection);
  };

  return (
    <Checkbox
      indeterminate={isIndeterminate}
      checked={allSelection}
      onChange={handleAllSelectionChange}
      disabled={disableStatus || !isDataPresent}
    />
  );
};
